import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=19c3e8e1&scoped=true"
import script from "./OfferDetail.vue?vue&type=script&lang=js"
export * from "./OfferDetail.vue?vue&type=script&lang=js"
import style0 from "./OfferDetail.vue?vue&type=style&index=0&id=19c3e8e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3e8e1",
  null
  
)

export default component.exports